// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__2L04Z","divider_ctrl":"divider_divider_ctrl__1srcb"};